import mq from 'js-mq';
import EventEmitter from 'events';
import SyosGlobalConfig from '../SyosGlobalConfig';
import SyosEvents from './SyosEvents';

const MOBILE_KEY = 'syos-mobile';
const TABLET_KEY = 'syos-tablet';

mq.register([
  { name: MOBILE_KEY, query: SyosGlobalConfig.mobileMediaQuery },
  { name: TABLET_KEY, query: SyosGlobalConfig.tabletMediaQuery },
]);


class SyosMediaQuery extends EventEmitter {
  constructor() {
    super();

    mq.on(MOBILE_KEY, () => {
      this.emit(SyosEvents.MOBILE_ENTER);
    });

    mq.on(`not-${MOBILE_KEY}`, () => {
      this.emit(SyosEvents.MOBILE_LEAVE);
    });

    mq.on(TABLET_KEY, () => {
      this.emit(SyosEvents.TABLET_ENTER);
    });

    mq.on(`not-${TABLET_KEY}`, () => {
      this.emit(SyosEvents.TABLET_LEAVE);
    });
  }

  testIsMobile() {
    return mq.is(MOBILE_KEY);
  }

  testIsTablet() {
    return mq.is(TABLET_KEY);
  }
}

const syosMediaQuery = new SyosMediaQuery();

export default syosMediaQuery;



// WEBPACK FOOTER //
// ./src/syos/utils/syosMediaQuery.js